import './NotFound.css'
import React from "react";

const NotFound = () => {
    return ( 
        <div className="NotFound">
           <h1>Oops!! This page does not exist.</h1>
           <h2>Click here to go to the main page.</h2>
        </div>
     );
}
 
export default NotFound;